import React, { useMemo } from 'react';
import { SnapshotPreviewProps } from './types';
import { CardMedia } from '@mui/material';
import { useGetCameraSnapshotQuery } from '@kinetic-ui/data-layer';
import { useTranslation } from 'react-i18next';
import useSnapshotPreviewStyles from './styles';
import clsx from 'clsx';

const SnapshotPreview: React.FunctionComponent<SnapshotPreviewProps> = (props) => {
  const { className, cameraId } = props;
  const { t } = useTranslation('video');
  const classes = useSnapshotPreviewStyles();

  const result = useGetCameraSnapshotQuery({ variables: { cameraId: cameraId } });

  const snapshotUrl = useMemo(
    () => result.data?.getCameraSnapshot ?? undefined,
    [result.data?.getCameraSnapshot]
  );

  const renderImagePreview = () => {
    return (
      <CardMedia
        component='img'
        alt={t('snapshotNotFound')}
        image={snapshotUrl}
        className={clsx(classes.cardWrapper, className)}
      />
    );
  };
  return renderImagePreview();
};

export default SnapshotPreview;
